module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7loROh/tc-custom/9781625845979.jpg?1705025941567",
      "alt": "This image is the cover for the book Trailer Food Diaries Cookbook: Portland Edition, Volume 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Trailer Food Diaries Cookbook: Portland Edition, Volume 2\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“Profiles many of our most popular purveyors on wheels, and includes . . . recipes so cart-ivores can recreate their favorite dishes at home.” —"), _c('i', [_vm._v("Mid-County Memo")])])]), _vm._v(" Portlanders have always had a taste for fresh local foods served up with a lack of pretense. So it’s no surprise that food carts have emerged as a popular way to showcase a variety of flavors to hungry locals. While the business is a competitive one, the most unique and culturally diverse food trucks are able to thrive. From new spins on old classics—like the meatball sub and the spinach salad—to innovative creations like the Sriracha Mix-a-Lot and Peppered Peanut Popcorn Brittle, food carts have established a presence as culinary gems in a city brimming with creative dining options. Join Tiffany Harelik, author of the Trailer Food Diaries Cookbook series, as she returns to Portland to celebrate this growing food revolution.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tiffany Harelik\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    American Palate\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0